export default class EventBus {
    constructor() {
        this.events = {}; // Holds all events and their listeners
    }

    /**
     * Subscribe to an event.
     * @param {string} eventName - Name of the event to listen for.
     * @param {Function} listener - Callback function to invoke when the event is emitted.
     */
    on(eventName, listener) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(listener);
    }

    /**
     * Unsubscribe from an event.
     * @param {string} eventName - Name of the event.
     * @param {Function} listener - The listener to remove.
     */
    off(eventName, listener) {
        if (!this.events[eventName]) return;
        this.events[eventName] = this.events[eventName].filter(
            (registeredListener) => registeredListener !== listener
        );
    }

    /**
     * Emit an event, calling all subscribed listeners.
     * @param {string} eventName - Name of the event to emit.
     * @param  {...any} args - Arguments to pass to the listeners.
     */
    emit(eventName, ...args) {
        if (!this.events[eventName]) return;
        this.events[eventName].forEach((listener) => listener(...args));
    }

    /**
     * Subscribe to an event for a single invocation.
     * @param {string} eventName - Name of the event to listen for.
     * @param {Function} listener - Callback function to invoke when the event is emitted.
     */
    once(eventName, listener) {
        const onceListener = (...args) => {
            listener(...args);
            this.off(eventName, onceListener); // Automatically unsubscribe
        };
        this.on(eventName, onceListener);
    }
}
